import styled from "styled-components";
import theme from "~/styles/theme";

export const ContainerHolder = styled.div`
  background-color: ${theme.palette.brand.secondary.key};
  padding: 20px 0;

  svg {
    max-height: 40px;
    height: auto;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      max-height: 56px;
    }
  }

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(calc(-250px * 7));
    }
  }

  .slick-slider {
    overflow: hidden;

    .slick-slide {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .slick-track {
      animation: scroll 40s linear infinite;
      display: flex;
    }
  }
`;
